import { Card, CardContent, Typography } from "@mui/material";
import type React from "react";

export const WebhooksTab: React.FC = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="div">
          Your webhooks
        </Typography>
        <Typography variant="body2" mt={1} color="text.secondary">
          You can setup webhooks to receive notifications when a test run is finished.
        </Typography>
      </CardContent>
    </Card>
  );
};
